import { DragDropContext, Draggable, Droppable, DropResult, ResponderProvided } from "@hello-pangea/dnd";
import { LocationPageInterface, LocationVarInheritance, LocationVarKey, LocationVarWithId, MergedLocationVar, SpotDataButton, SpotDataButtonStyle } from "@swivl-mono/types";
import { Button, ButtonVariant, InheritancePill, Spinner, SpotLocationButton } from "@swivl-mono/ui";
import React from "react";
import LocationVarsModel from "../../../../Models/Variables/LocationVars.Model";
import { nanoid } from "nanoid";

interface Props {
	buttons?: any;
	buttonsVar?: MergedLocationVar;
	setSelectedButtonId(id: string): void;
	setButtons(data: SpotDataButton[]): void;
	selectedButtonId?: string;
	page: LocationPageInterface

}

export function SpotButtonsView(props: Props) {
	const { buttons, setSelectedButtonId, selectedButtonId, buttonsVar, page } = props;
	const [isLoading, setIsLoading] = React.useState(false);

	if (!buttonsVar) {
		return <Spinner />
	}
	const onDragEnd = (result: DropResult, provided: ResponderProvided) => {
		if (!result.destination) {
			return;
		}
		const items = [...buttons];
		const [reorderedItem] = items.splice(result.source.index, 1);
		items.splice(result.destination.index, 0, reorderedItem);
		props.setButtons(items);
	}

	const customize = async () => {
		if (!buttonsVar) {
			return;
		}
		setIsLoading(true);
		await LocationVarsModel.createVariable(LocationVarKey.SpotButtons, buttonsVar.value, props.page.groupId, props.page.locationId);
		setIsLoading(false);
	};

	const editable = buttonsVar.inheritance === LocationVarInheritance.NONE

	const buttonViews = buttons ? buttons.map((item, index) => {
		return <Draggable draggableId={"draggable_" + index} index={index} >
			{
				(provided, snapshot) => (
					<div key={item.id} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} className={selectedButtonId === item.id ? "poppyBG rounded-lg pt-1 px-1 pb-1 mb-2" : " mb-2"}
						onClick={() => {
							setSelectedButtonId(item.id);
						}}
					>
						<SpotLocationButton key={item.id} button={item} builderButton={true} />
					</div>
				)
			}
		</Draggable>


	}) : null;

	return (
		<div className="relative w-full">
			{!editable && <div className="customizeOverlay z-50 absolute inset-0 bg-blue bg-opacity-90 flex justify-center items-center"
				onClick={() => {
					if (!isLoading) {
						customize()
					}
				}}
			>
				<div className="text-lg font-bold">{isLoading ? <Spinner /> : "Customize"}</div>
			</div>}
			<DragDropContext
				onDragEnd={onDragEnd}
				onDragStart={(e: any) => {
				}}
			>
				<div className="z-10 px-5 md:px-10 relative flex flex-col w-full justify-center items-center  mx-auto bg-white overflow-hidden md:max-w-2xl">
					<Droppable droppableId={"spot_dropable"} type="BUTTON" >
						{(provided, snapshot) => (
							<div
								ref={provided.innerRef}
								className="w-full"
								style={{ backgroundColor: snapshot.isDraggingOver ? '#C3BCB9' : 'transparent', borderRadius: 3, padding: "0 0 20px 0" }}
								{...provided.droppableProps}>
								{provided.placeholder}
								{buttonViews}
							</div>
						)}
					</Droppable>
					{editable && (
						<div className="w-full flex justify-center items-center">
							<Button
								fullWidth
								variant={ButtonVariant.DASHED}
								onClick={() => {
									props.setButtons([
										...buttons,
										{
											id: nanoid(8),
											title: "New Button",
											href: "#",
											icon: "",
											style: SpotDataButtonStyle.PRIMARY,
										}
									]);
								}}>
								Add Button
							</Button>
						</div>
					)}

					{buttonsVar && buttonsVar.id && buttonsVar.inheritance !== LocationVarInheritance.DEFAULT && (
						<div className="pt-2 mb-3">
							<InheritancePill
								alwaysShow={true}
								inheritance={buttonsVar.inheritance}
								isEditing={true}
								canRevert={true}
								customText={{
									fromGroup: "Inherited from Group",
									fromOrg: "Inherited from Org",
									default: "Inherited from default",
								}}
								onClick={function (): void {
									if (confirm("Are you sure you want to revert these buttons?")) {
										const locationVarWithId: LocationVarWithId = {
											id: buttonsVar.id!,
											key: buttonsVar.key,
											value: buttonsVar.value
										}
										LocationVarsModel.deleteVariable(locationVarWithId);

									}
								}}
							/>
						</div>
					)}
				</div>
			</DragDropContext>
		</div>
	);
}
